import React from 'react'

export default ({ children }) => {
  return (
    <ul>{children}</ul>
  );
}


// WEBPACK FOOTER //
// ./src/components/List/List.js